// Remove the following lines, if you do not need any of Bootstrap's JavaScript features
// import bootstrap from "bootstrap";
// import Parallax from 'parallax-js'
import $ from "jquery";
window.jQuery = $;
window.$ = $;
require ('jquery-parallax.js');
var Masonry = require('masonry-layout');
import mediumZoom from 'medium-zoom';
import 'slick-carousel';
require('paroller.js');
// import WOW from'wowjs'
// const WOW = require('wowjs');

const fullLang = document.documentElement.lang || navigator.language;
const isoLang = fullLang.split('-')[0].toLowerCase();
// import simpleParallax from 'simple-parallax-js';


const bootstrap = window.bootstrap = require('bootstrap');
// var parallax_images = document.getElementsByClassName('parallax');
// new simpleParallax( parallax_images,{
//     overflow: false
//     // scale: 1.05
//     // orientation: 'right'
// });

var stickyHeaderHeight = 200 ;

if(document.querySelector('.grid')){
    var msnry = new Masonry( '.grid', {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true
    });
}

let slick_partenaires_responsive =  [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    }
  ];
let slick_articles_responsive =  [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ];

$('.slick-partenaires').slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 6,
    slidesToScroll : 3,
    arrows: false,
    responsive: slick_partenaires_responsive
   
});

$('.slick-programme').slick({
    // slide: 'li',
    // infinite: true,
    // autoplay: true,
    slidesToShow: 2,
    slidesToScroll : 2,
    responsive: slick_articles_responsive
   
});
$('.slick-partenaires2').slick({
    // slide: 'li',
    // infinite: true,
    // autoplay: true,
    slidesToShow: 2,
    slidesToScroll : 2,
    responsive: slick_articles_responsive
   
});

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

$(function() { 

    $('.wpml-ls-item-fr').find('a').each(function(){
        let _href = $(this).attr('href');
        $(this).attr('href', _href.replace('.com', '.fr')) ;
    });

    $('.wpml-ls-flag').each(function () {
        $(this).attr('src', $(this).attr('data-src')) ;
    });


    /**
     * Redirection form compétiteurs vers la page panier.
     */


    document.addEventListener( 'wpcf7mailsent', function( event ) {
        setTimeout( () => {
            console.log(event);
            console.log(event?.detail?.contactFormId);
            console.log(event?.detail?.contactFormId === 2098);
            if(event?.detail?.contactFormId === 157  || event?.detail?.contactFormId === 2098  ){
                  window.location.href = '/commander/'; // FR
            }
            else if(event?.detail?.contactFormId === 970  || event?.detail?.contactFormId === 2100 || event?.detail?.contactFormId === 2137){
                  window.location.href = '/checkout/'; // EN
            }
        }, 3000 ); // Wait for 3 seconds to redirect.
    }, false );

     /**
     * Anchor smooth scroll
     */
      $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .on('click', function(event) {
          // On-page links
          if (
              location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
              && 
              location.hostname == this.hostname
          ) {
              // Figure out element to scroll to
              var target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
              // Does a scroll target exist?
              if (target.length) {
                  // Only prevent default if animation is actually gonna happen
                  event.preventDefault();
                  document.documentElement.scrollTo({
                      top: target.offset().top - stickyHeaderHeight,
                      behavior: "smooth"
                  });
                  if($(this).parents('#navbarMain').length){
                    const bsCollapse = new bootstrap.Collapse('#navbarMain', {
                        hide: true
                      })
                  }
                 
              }
          }
      });

    $('.accordion-collapse').on('shown.bs.collapse', function (e) {
        var $panel = $(this).closest('.accordion-item');
        document.documentElement.scrollTo({
            top: $panel.offset().top - stickyHeaderHeight,
            behavior: "smooth"
        });
    });

    //Clone burger icon to overlay menu
    $('.navbar-fixed-opened').on('show.bs.collapse', function () {
        $('.navbar-closer').remove();
        $('.navbar-fixed-opened').prepend(`<button class="navbar-toggler navbar-closer" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMain" aria-controls="navbarMain" aria-expanded="true" aria-label="Fermer">
        <i class="fa fa-lg fa-times"></i></button>`);
    }) ;

    // Close menu & overlays when Escape
    $(document).on('keydown', function(e) {
        if (e.key == "Escape") {
            $('#navbarMain').collapse('hide');
            $('.agencea-overlay').removeClass('shown');
        }
    });

    //Wow
    if('function' === typeof WOW){
        new WOW().init();
    }
    

    // Sticky menu
    // if (window.matchMedia("(min-width: 768px)").matches) {
    //     window.addEventListener('scroll', function() {
    //         if (window.scrollY > 160) {
    //             $('#navbar-main')
    //                 .addClass('fixed-top')
    //                 // .addClass('bg-dark')
    //                 // .removeClass('bg-transparent');
    //             let navbar_height = document.querySelector('.navbar').offsetHeight;
    //             document.body.style.paddingTop = navbar_height + 'px';
    //             $('.logo-sticky').removeClass('d-none') ;
    //         } else {
    //             $('#navbar-main')
    //                 .removeClass('fixed-top')
    //                 // .removeClass('bg-dark')
    //                 // .addClass('bg-transparent');
    //             document.body.style.paddingTop = '0';
    //             $('.logo-sticky').addClass('d-none') ;
    //         } 
    //     });
    // }

    // $('.dropdown-toggle').dropdown();
    mediumZoom('[data-zoomable]');
    $("[data-paroller-factor]").wrap('<div class="paroller-wrap"></div>');
    $("[data-paroller-factor]").paroller();
    

    // jarallaxVideo();
    jarallax(document.querySelectorAll('.jarallax'), {
        speed: 0.2
    });

    // Menu
    $(".dropdown").hover(function(){
        var dropdownMenu = $(this).children(".dropdown-menu");
        if(dropdownMenu.is(":visible")){
            dropdownMenu.parent().toggleClass("open");
        }
    });


    $(document).on('click', '.navbar .dropdown-toggle', function(){
        if (window.matchMedia("(min-width: 992px)").matches) {
            window.location.href= $(this).attr('href');
        }
    });

    // Search form full screen [search_full_screen]
    $(document).on('click', '#search-full-screen__toggle', function(){
        $('#search-full-screen__target')
            .prepend(`<button class="navbar-toggler agencea-overlay__close" type="button" aria-controls="search-full-screen__form" aria-expanded="true" aria-label="Fermer">
        <i class="fa fa-lg fa-times"></i></button>`)
            .addClass('shown');
    });

    $(document).on('click', '.agencea-overlay__close', function(){
        $('.agencea-overlay')
            .removeClass('shown')
            .find('.agencea-overlay__close').remove();
           
    });
   



    // Counters
    $(window).on('scroll', function(){
        $('.count, .down_count').each(function () {
            if(isInViewport($(this)[0])){
                $(this).addClass('countAnimated');
            }
        });

        $('.count.countAnimated:not(.stopped)').each(function () {
                $(this).css('opacity', 1);
                $(this).prop('Counter',0).animate({
                    Counter: $(this).text()
                }, {
                    duration: 4000,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(Math.ceil(now));
                    }
                });
                $(this).addClass('stopped');
        });

        // Down Counters
        $('.down_count.countAnimated:not(.stopped)').each(function () {
                $(this).css('opacity', 1);
                $(this).prop('Counter',10).animate({
                    Counter: $(this).text()
                }, {
                    duration: 2000,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(Math.ceil(now));
                    }
                });
                $(this).addClass('stopped');
        });
    });
      


   //Scroll back to top
		
	var progressPath = document.querySelector('.progress-wrap path');
    if(progressPath){
		var pathLength = progressPath.getTotalLength();
		progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
		progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
		progressPath.style.strokeDashoffset = pathLength;
		progressPath.getBoundingClientRect();
		progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';		
		var updateProgress = function () {
			var scroll = $(window).scrollTop();
			var height = $(document).height() - $(window).height();
			var progress = pathLength - (scroll * pathLength / height);
			progressPath.style.strokeDashoffset = progress;
		}
		updateProgress();
		$(window).scroll(updateProgress);	
		var offset = 150;
		// var duration = 550;
		jQuery(window).on('scroll', function() {
			if (jQuery(this).scrollTop() > offset) {
				jQuery('.progress-wrap').addClass('active-progress');
			} else {
				jQuery('.progress-wrap').removeClass('active-progress');
			}
		});				
		jQuery('.progress-wrap').on('click', function(event) {
			event.preventDefault();
			document.documentElement.scrollTo({
                top: 0,
                behavior: "smooth"
            })
			return false;
		});
    }


    /**
     * Map dealers
     */

    if($('#contact_map').length > 0){
    

        $.post(agencea.ajaxurl, {'action':'geocode_contact_address'}, function(response){
            if(response.lat_lng != ""){
                var contactmap = L.map('contact_map', { dragging: !L.Browser.mobile, tap: !L.Browser.mobile }).setView([response.lat_lng.lat, response.lat_lng.lng], 15);

                L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZmxpc3RlZmxpc3RlIiwiYSI6ImNpeGt2bnliczAwMjIycW4wMmkwMzI3c2UifQ.fYceJb6F_mtjN3fmXz0wMQ', {
                    maxZoom: 18,
                    // attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, ' +
                    //     'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
                    id: 'mapbox/streets-v11',
                    tileSize: 512,
                    zoomOffset: -1
                }).addTo(contactmap);
           
                var marker = L.marker([response.lat_lng.lat, response.lat_lng.lng], {title:response.name+'<br>'+response.address}).addTo(contactmap);
                marker.bindPopup(response.name+'<br>'+response.address).openPopup();
                    
            }
        
        });

       

        // $('.dealers-list > li').on('click', function(){
        //     var id = $(this).data('id') ;
        //     var _marker = dealersmap.getMarkerById(id);
        //     _marker.fire('click');
        // });
    }


    if($('#dealers').length > 0){
        // Get marker by ID
        L.Map.include({
            getMarkerById: function (id) {
                var marker = null;
                this.eachLayer(function (layer) {
                    if (layer instanceof L.Marker) {
                        if (layer.options.id === id) {
                            marker = layer;
                        }
                    }
                });
                return marker;
            }
        });


        var dealersmap = L.map('dealers', { dragging: !L.Browser.mobile, tap: !L.Browser.mobile }).setView([44.8947086,-0.2065675], 2);

        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZmxpc3RlZmxpc3RlIiwiYSI6ImNpeGt2bnliczAwMjIycW4wMmkwMzI3c2UifQ.fYceJb6F_mtjN3fmXz0wMQ', {
            maxZoom: 18,
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, ' +
                'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            id: 'mapbox/streets-v11',
            tileSize: 512,
            zoomOffset: -1
        }).addTo(dealersmap);


        var markers = [] ;

        $.get('/wp-json/wp/v2/location', function(response){
            if(response.length > 0){
                for (let i = 0; i < response.length; i++) {
                    const element = response[i];
                    if(element.acf.coords.lat != '' && element.acf.coords.lng != ''){
                        var marker = L.marker([element.acf.coords.lat, element.acf.coords.lng], {title:element.title.rendered,id:element.id}).addTo(dealersmap);
                        marker.bindPopup(element.title.rendered).openPopup();
                        markers.push(marker);
                        marker.on('click', onClick);
                    }
                    
                }
                var group = new L.featureGroup(markers);
                dealersmap.fitBounds(group.getBounds());
            }
        
        });

        function onClick(e) {
            var id = e.target.options.id ;
            $('.dealers-list').find('li').removeClass('list-group-item-primary');
            $('.dealers-list').find('[data-id="'+id+'"]').addClass('list-group-item-primary');
            $('.dealers-list').find('[data-id="'+id+'"]').parents('.accordion-item').find('.accordion-button.collapsed').trigger('click');
        }

        $('.dealers-list > li').on('click', function(){
            var id = $(this).data('id') ;
            var _marker = dealersmap.getMarkerById(id);
            _marker.fire('click');
        });
    }


    /** Countdown event */
    // Set the date we're counting down to
    if(document.getElementById("countdown")) {
        let countdown = document.getElementById("countdown") ;
        
        var countDownDate = new Date("Oct 22, 2026 09:00:00").getTime();

        // Update the count down every 1 second
        var x = setInterval(function() {

        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;


        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Display the result in the element with id="demo"
        countdown.innerHTML = days + " jours<br>" + hours + "h "
        + minutes + "min " + seconds + "s ";

        // If the count down is finished, write some text
        if (distance < 0) {
            clearInterval(x);
            countdown.innerHTML = "";
        }
        }, 1000);
    }

    
   
});





